<template>
  <b-overlay :show="show" rounded="md">
    <b-container id="main-container" fluid style>
      <b-row style="width: 100%; background-color: #e8e8ea" align-h="center">
        <b-col class="" cols="12">
          <nav-header></nav-header>
        </b-col>
      </b-row>
      <b-container
        class="confirmsection"
        style="
          max-width: 100% !important;
          padding-top: 48px;
          padding-bottom: 75px;
        "
      >
        <b-row align-h="center" style="width: 100%">
          <b-col cols="12" class="pl-0 pr-0" style="max-width: 1200px">
            <b-row style="margin-top: 90px">
              <b-col
                md="12"
                class="align-center-small"
                style="color: #111111; font-size: 34px; padding-bottom: 0px"
                >Thank you for your purchase!</b-col
              >
            </b-row>
            <b-row class="pt-2">
              <b-col style="font-size: 16px"
                >Please check your email for order confirmation. Visit us
                again!</b-col
              >
            </b-row>

            <b-row class="pt-5">
              <b-col style="font-size: 16px" v-if="order"
                >Your order number is: {{ order.data.id.split("_")[1] }}</b-col
              >
            </b-row>
            <b-row>
              <b-col cols="12" class="pl-0 pr-0">
                <hr style="width: 100%; border: 0.5px solid #c6e3f7" />
              </b-col>
            </b-row>

            <b-row class="pt-1">
              <b-col style="font-size: 20px" v-if="getKioskID()==null">Shipping Address</b-col>
              <b-col style="font-size: 20px" v-else>Billing Address</b-col>
            </b-row>
            <b-row class="pt-3">
              <b-col>
                <p style="font-size: 16px" v-if="form">
                  {{ form.fname.toUpperCase() }} {{ form.lname.toUpperCase() }}
                </p>
                <p style="font-size: 16px" v-if="form">
                  {{ form.address1.toUpperCase() }}
                </p>
                <p v-if="form && form.address2" style="font-size: 16px">
                  {{ form.address2.toUpperCase() }}
                </p>
                <p v-if="form" style="font-size: 16px">
                  {{ form.city.toUpperCase() }}, {{ form.state.toUpperCase() }},
                  {{ form.zipcode.toUpperCase() }},
                  {{ form.country.toUpperCase() }}
                </p>
                <p v-if="form" style="font-size: 16px; margin-bottom: 0px">
                  {{ form.email.toUpperCase() }}
                </p>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" class="pl-0 pr-0">
                <hr style="width: 100%; border: 0.5px solid #c6e3f7" />
              </b-col>
            </b-row>
            <b-row class="pt-1">
              <b-col style="font-size: 20px">Payment Method</b-col>
            </b-row>
            <b-row class="pt-1 pb-3">
              <b-col cols="12" class="pt-2">
                <span>
                  <b-img
                    :src="getBrandImg()"
                    class="card-icon"
                    style="padding-right: 5px"
                  ></b-img>
                  <b style="padding-right: 15px">{{ getLast4() }}</b>
                  <b>{{ getExp() }}</b>
                </span>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" class="pl-0 pr-0">
                <hr style="width: 100%; border: 0.5px solid #c6e3f7" />
              </b-col>
            </b-row>
            <b-row class="pt-1">
              <b-col style="font-size: 20px">Delivery</b-col>
            </b-row>
            <b-row class="pt-3">
              <b-col style="font-size: 16px" v-if="getKioskID() == null">
                On or before: {{ getDelivery() }}
              </b-col>
              <b-col style="font-size: 16px" v-else> Kiosk Self-Pickup </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" class="pl-0 pr-0">
                <hr style="width: 100%; border: 0.5px solid #c6e3f7" />
              </b-col>
            </b-row>
            <b-row class="pt-1">
              <b-col style="font-size: 16px">
                If you have any questions during your ordering process, please
                <a href="/#/contact"> contact us</a>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-container>

      <b-row style="width: 100%">
        <nav-footer></nav-footer>
      </b-row>
    </b-container>
  </b-overlay>
</template>

<script>
import NavHeader from "./../components/NavHeader";
import NavFooter from "./../components/NavFooter";
import storage from "../storage";

export default {
  name: "Confirm",
  components: {
    NavHeader,
    NavFooter,
  },
  data() {
    return {
      order: null,
      form: null,
      token: null,
      show: false,
    };
  },
  methods: {
    getKioskID() {
      return storage.getKiosk();
    },
    getDelivery() {
      var d = new Date();
      var x = 6;
      if (this.form!=null && this.form.country!=null && this.form.country.toUpperCase() != "US") {
        x = 14;
      }
      d.setDate(d.getDate() + x);
      return d.toLocaleDateString();
    },
    getBrandImg() {
      var token = this.token;
      try {
        if (token != null) {
          if (token.data.card.brand.toLowerCase() == "visa") {
            return "img/visa@2x.png";
          } else if (token.data.card.brand.toLowerCase() == "unionpay") {
            return "img/union-pay@2x.png";
          } else if (token.data.card.brand.toLowerCase() == "mastercard") {
            return "img/mastercard@2x.png";
          } else if (token.data.card.brand.toLowerCase() == "discover") {
            return "img/discover@2x.png";
          } else if (token.data.card.brand.toLowerCase() == "diners club") {
            return "img/diners-club@2x.png";
          } else if (token.data.card.brand.toLowerCase() == "jcb") {
            return "img/jcb@2x.png";
          } else if (
            token.data.card.brand.toLowerCase() == "american express"
          ) {
            return "img/american-express@2x.png";
          } else {
            return "img/generic@2x.png";
          }
        } else {
          return "img/generic@2x.png";
        }
      } catch (err) {
        return "img/generic@2x.png";
      }
    },
    getLast4() {
      if (this.token != null) {
        return this.token.data.card.last4;
      } else {
        return "xxxx";
      }
    },
    getExp() {
      if (this.token != null) {
        return (
          "Expiration: " +
          this.token.data.card.exp_month +
          "/" +
          this.token.data.card.exp_year
        );
      }
    },
  },
  mounted() {
    this.order = this.$store.orderpaid;
    this.form = this.$store.orderform;
    this.token = this.$store.ordertoken;
    if (this.order == null || this.form == null) {
      window.location.href = "/#/select";
    }
  },
};
</script>

<style lang="scss">
.card-icon {
  height: 20px;
}

.confirmsection {
  min-height: calc(100vh - 169px) !important;
}
</style>